import './App.css';
import Portfolio from './Portfolio';

function App() {
  return (
    <div className="App">
      {/* This renders your entire modular portfolio structure */}
      <Portfolio />
    </div>
  );
}

export default App;